module.exports = __webpack_public_path__ + "img/zhongbiaopeishi.d90dd499.png";